import { Grid, Stack } from "@mui/material";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import TopSection from "../../../Components/Common/Top/TopSection";
import { CIBottlerSelectionProvider } from "../../../context/CIBottlerSelectionContext";
import { CICustomBottlerSelectionProvider } from "../../../context/CICustomBottlerSelectionContext";
import CIManageForecastMainContent from "./CIManageForecastMainContent";
import { setActiveDataElement } from "../../../redux/userSlice";

const CIManageForecast = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setActiveDataElement("Concentrate Inventory"));
  }, [dispatch]);

  return (
    <>
      <Stack>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TopSection title="Manage Concentrate Inventory File" />
            <div className="container">
              <CIBottlerSelectionProvider>
                <CICustomBottlerSelectionProvider>
                  <CIManageForecastMainContent></CIManageForecastMainContent>
                </CICustomBottlerSelectionProvider>
              </CIBottlerSelectionProvider>
            </div>
          </Grid>
        </Grid>
      </Stack>
    </>
  );
};

export default CIManageForecast;
